import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { $getSelection } from "lexical";
import { useTheme } from "@mui/material/styles";
import { $patchStyleText } from "@lexical/selection";
import { MenuItem } from "../../../../../MenuItem/index.js";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
const useBgColorsItems = (editor, activeColor)=>{
    const $ = c(18);
    const theme = useTheme();
    let t0;
    if ($[0] !== theme.tokens.colors.accent.stroke.blue || $[1] !== theme.tokens.colors.accent.stroke.error || $[2] !== theme.tokens.colors.accent.stroke.review || $[3] !== theme.tokens.colors.accent.stroke.success || $[4] !== theme.tokens.colors.accent.stroke.warning || $[5] !== theme.tokens.colors.bg.light.primary || $[6] !== theme.tokens.colors.stroke.primary) {
        t0 = {
            [theme.tokens.colors.bg.light.primary]: "\u0411\u0435\u043B\u044B\u0439",
            [theme.tokens.colors.stroke.primary]: "\u0421\u0435\u0440\u044B\u0439",
            [theme.tokens.colors.accent.stroke.blue]: "\u0421\u0438\u043D\u0438\u0439",
            [theme.tokens.colors.accent.stroke.success]: "\u0417\u0435\u043B\u0435\u043D\u044B\u0439",
            [theme.tokens.colors.accent.stroke.warning]: "\u041E\u0440\u0430\u043D\u0436\u0435\u0432\u044B\u0439",
            [theme.tokens.colors.accent.stroke.error]: "\u041A\u0440\u0430\u0441\u043D\u044B\u0439",
            [theme.tokens.colors.accent.stroke.review]: "\u0424\u0438\u043E\u043B\u0435\u0442\u043E\u0432\u044B\u0439"
        };
        $[0] = theme.tokens.colors.accent.stroke.blue;
        $[1] = theme.tokens.colors.accent.stroke.error;
        $[2] = theme.tokens.colors.accent.stroke.review;
        $[3] = theme.tokens.colors.accent.stroke.success;
        $[4] = theme.tokens.colors.accent.stroke.warning;
        $[5] = theme.tokens.colors.bg.light.primary;
        $[6] = theme.tokens.colors.stroke.primary;
        $[7] = t0;
    } else t0 = $[7];
    const ColorTypeToBlockName = t0;
    let t1;
    if ($[8] !== editor) {
        const applyStyleText = (styles)=>{
            editor.update(()=>{
                const selection = $getSelection();
                if (null !== selection) $patchStyleText(selection, styles);
            });
        };
        t1 = (value, type)=>{
            applyStyleText({
                [type]: value
            });
        };
        $[8] = editor;
        $[9] = t1;
    } else t1 = $[9];
    const onFontColorSelect = t1;
    let t2;
    if ($[10] !== ColorTypeToBlockName) {
        t2 = Object.entries(ColorTypeToBlockName);
        $[10] = ColorTypeToBlockName;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== activeColor || $[13] !== onFontColorSelect || $[14] !== t2 || $[15] !== theme.tokens.colors.bg.light.primary || $[16] !== theme.tokens.colors.stroke.primary) {
        t3 = t2.map((t4)=>{
            const [color, name] = t4;
            return /*#__PURE__*/ jsx(MenuItem, {
                onClick: ()=>onFontColorSelect(color, "background-color"),
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    alignItems: "center",
                    gap: "8",
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            width: "16px",
                            height: "16px",
                            radius: "xs",
                            style: {
                                backgroundColor: color,
                                border: `1px solid ${color === theme.tokens.colors.bg.light.primary ? theme.tokens.colors.stroke.primary : "transparent"}`
                            },
                            border: "1px solid"
                        }),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body3",
                            color: activeColor === color ? "original.brand.primary" : "text.light.primary",
                            children: name
                        })
                    ]
                })
            }, color);
        });
        $[12] = activeColor;
        $[13] = onFontColorSelect;
        $[14] = t2;
        $[15] = theme.tokens.colors.bg.light.primary;
        $[16] = theme.tokens.colors.stroke.primary;
        $[17] = t3;
    } else t3 = $[17];
    return t3;
};
export { useBgColorsItems };
